// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2xPXj","disabled":"FileBtn_disabled__2y_VL","warn":"FileBtn_warn__21PjW","fade":"FileBtn_fade__3XRXy"};